(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-verification"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const AGE_CONFIRM_KEY = "ageConfirmed";
  const EXPIRY_KEY = "ageConfirmedExpiry";
  const DAYS_VALID = 30;

  function isAgeConfirmed() {
    const confirmed = localStorage.getItem(AGE_CONFIRM_KEY);
    const expiry = localStorage.getItem(EXPIRY_KEY);

    if (!confirmed || !expiry) return false;

    const now = new Date().getTime();
    return now < parseInt(expiry);
  }

  if (!isAgeConfirmed()) {
    const agePopup = document.createElement("div");
    agePopup.innerHTML = `
      <div class="bk-age-popup-overlay">
        <div class="bk-age-popup">
          <img src="https://cdn.shopify.com/s/files/1/0659/1237/3299/files/blinkers-text-logo-black.png?v=1755295484" class="bk-logo">
          <p>You must be 21 years or older to enter.</p>
          <div class="bk-age-buttons">
            <button id="bk-confirm-yes">Yes, I am</button>
            <button id="bk-confirm-no">No</button>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(agePopup);

    document.getElementById("bk-confirm-yes").addEventListener("click", function () {
      const now = new Date().getTime();
      const expiry = now + DAYS_VALID * 24 * 60 * 60 * 1000;

      localStorage.setItem(AGE_CONFIRM_KEY, "true");
      localStorage.setItem(EXPIRY_KEY, expiry.toString());
      document.body.removeChild(agePopup);
    });

    document.getElementById("bk-confirm-no").addEventListener("click", function () {
      window.location.href = "https://www.google.com";
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
